import React from 'react'
import Routes from '@brainstud/react-tbl/themes/pgw/v1/routes'
import { Switch, Route } from 'react-router-dom'
import { scrollTop } from '@brainstud/react-tbl/themes/pgw/v1/helpers'
import { AppView, AppContainer, AppHeader, AppContent } from '@brainstud/react-tbl/themes/pgw/v1/components/layout'
import EndtestQuestionView from './EndtestQuestionView'
import EndtestIntroView from './EndtestIntroView'
import EndtestSummaryView from './EndtestSummaryView'

class EndtestRootView extends React.Component {
  componentDidMount() {
    scrollTop()
  }

  render() {
    return (
      <AppView name="Endtest">
        <AppHeader />

        <AppContent>
          <Switch>
            <Route path={Routes.to('endtest')} exact component={EndtestIntroView} />
            <Route path={Routes.to('endtestSummary')} component={EndtestSummaryView} />
            <Route path={Routes.to('endtestQuestion')} component={EndtestQuestionView} />
          </Switch>
        </AppContent>
      </AppView>
    )
  }
}

export default EndtestRootView